var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeneficery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50391 13.1738C12.8423 13.1738 16.5036 13.8789 16.5039 16.5986C16.5039 19.3196 12.8185 20 8.50391 20C4.1664 20 0.504115 19.295 0.503906 16.5752C0.503906 13.8542 4.18929 13.1738 8.50391 13.1738ZM8.50488 0C11.4438 0.000205204 13.7988 2.35413 13.7988 5.29102C13.7988 8.22792 11.4438 10.5828 8.50488 10.583C5.56678 10.583 3.21094 8.22804 3.21094 5.29102C3.21096 2.35401 5.5668 0 8.50488 0Z",
    fill: "#9983FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneficery);
export default __webpack_public_path__ + "static/media/beneficery.20185da2736854c95bf84b3e67ca41e4.svg";
export { ForwardRef as ReactComponent };